import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { AuthServicesService } from 'src/app/services/auth-services.service';

@Component({
  selector: 'app-recuperer-mdp',
  templateUrl: './recuperer-mdp.component.html',
  styleUrls: ['./recuperer-mdp.component.scss']
})
export class RecupererMdpComponent implements OnInit {

  courriel:string = '';
  constructor(private auth:AuthServicesService, private app:AppComponent) { }

  ngOnInit(): void {
  }
  emailValidation(): boolean{
    const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-\.]+\.[a-zA-Z0-9-]{2,}$/;
    if(this.courriel.match(mailformat)){return true;}else{return false;}
  }
  resetPassword(){
    if(this.emailValidation()){
      this.auth.resetPassword(this.courriel).then( () => {
        this.app.showMessage(1,'Nous vous envoyons un lien de réinitialisation.',3000);
        this.app.navigateTo('/');
      })
    }else{
      this.app.showMessage(3,'Le format de votre adresse courriel n\'est pas correcte.',3000);
    }
  }
}
